import React from "react";
import { Location } from "../Location";
import TicketProfile from "@tickets/TicketProfile/TicketProfile";
import { withErrorBoundary } from "@common/error-boundary";

interface Params {
  ticketId: string;
}

export class TicketProfileLocation extends Location<Params> {
  constructor(ticketId: string) {
    super({ ticketId });
  }

  render() {
    const { ticketId } = this.params;
    return withErrorBoundary(<TicketProfile id={ticketId} />);
  }

  toURI() {
    const { ticketId } = this.params;
    return `/dashboard/tickets/${ticketId}`;
  }
}
